import React from 'react';
import Form from "./Form";

const Ro = () => {
    return (
        <div className="info-pages-main-content">
            <div className="info-page-inner-content price-list">
                <h4>Instrucțiuni pentru ștergerea datelor:</h4>
                <p>
                    Dacă doriți să vă ștergeți datele din
                    <a href="https://ifurn.pro/" className="" target={'_blank'}> iFurn.pro</a>,
                    Vă rugăm să furnizați informațiile dvs. de contact pentru ștergere și motivul.
                </p>
            </div>
            <Form/>

        </div>

    );
};

export default Ro;